/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProjectSecurityVM { 
    projectId?: number;
    isActive?: boolean | null;
    name?: string | null;
    userId?: number;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    schoolId?: number | null;
    checkoutdevice?: boolean;
    registerDevice?: boolean;
    scanDevice?: boolean;
    registerSchool?: boolean | null;
    isAdmin?: boolean | null;
    schoolName?: string | null;
    hasAnalytics?: boolean;
    hasReadingCamp?: boolean;
    hasParticipations?: boolean;
    hasDocuments?: boolean;
    hasDevices?: boolean;
    hasContacts?: boolean;
    startDate?: string | null;
    endDate?: string | null;
}

